// Justo después de pagar: ¿esta cuenta debe el onboarding de marca?
// (ADR-2026-10-31-onboarding-corto-para-la-prueba)
//
// El rebote de `App` corre sólo en eventos de sesión, y el plan lo escribe el webhook, quizás
// tarde. Así que quien paga en la misma pestaña no lo agarraría nadie: la pantalla de éxito
// pregunta acá, y si lo debe deja el flag en memoria en `'marca'`. Con eso, toda salida de la
// cadena post-pago (la facturación, la llamada) hacia la app cae en el guardia y vuelve al
// onboarding de marca. "No se sabe" es "no": la cadena sigue como siempre.

import { leerOnboardingEnLaBase } from './cuestionarioEnLaBase';
import { marcarOnboardingPendiente } from './cuestionarioObligatorio';
import { recordarPagoConMarcaPendiente } from './pagoConMarcaPendiente';
import { supabase } from './supabase';

/** Tope de la lectura: el botón de "Continuar" espera esto, y nunca se queda colgado. */
export const ESPERA_MAXIMA_MS = 5_000;

export async function prepararOnboardingDeMarcaPostPago(esperaMaximaMs = ESPERA_MAXIMA_MS): Promise<boolean> {
  let corte: ReturnType<typeof setTimeout> | undefined;
  const debido = await Promise.race([
    leerOnboardingEnLaBase({ recienPago: true }),
    new Promise<'no_se_sabe'>((resolver) => {
      corte = setTimeout(() => resolver('no_se_sabe'), esperaMaximaMs);
    }),
  ]);
  clearTimeout(corte);
  if (debido !== 'marca') return false;
  marcarOnboardingPendiente('marca');
  // Y que sobreviva una recarga mientras el webhook escribe el plan.
  try {
    const { data } = await supabase.auth.getSession();
    const userId = data.session?.user?.id;
    if (userId) recordarPagoConMarcaPendiente(userId);
  } catch {
    /* queda el flag en memoria */
  }
  return true;
}
